import React from 'react';
import { Tooltip } from 'antd';
import { t } from 'i18next';

const DayLeftToolTip = (props) => {
    return (
        <div className="flex space-x-2">
            <div className="flex-1 text-xs">{t('Day Left')} :</div>
            <div className="cursor-pointer mt-0.5">
                <Tooltip
                    placement="bottom"
                    title={
                        <div className="grid">
                            <div className="flex">
                                <svg
                                    className="mr-2 mt-1"
                                    width={14}
                                    height={15}
                                    viewBox="0 0 14 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx={7}
                                        cy="7.5"
                                        r={7}
                                        fill="#1890FF"
                                    />
                                </svg>
                                {t('More than 7 days')}
                            </div>
                            <div className="flex">
                                <svg
                                    className="mr-2 mt-1"
                                    width={14}
                                    height={15}
                                    viewBox="0 0 14 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx={7}
                                        cy="7.5"
                                        r={7}
                                        fill="#F9C153"
                                    />
                                </svg>
                                {t('1-7 days')}
                            </div>
                            <div className="flex">
                                <svg
                                    className="mr-2 mt-1"
                                    width={14}
                                    height={15}
                                    viewBox="0 0 14 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx={7}
                                        cy="7.5"
                                        r={7}
                                        fill="#F0536F"
                                    />
                                </svg>
                                {t('Less than 1 days')}
                            </div>
                        </div>
                    }
                >
                    <svg
                        width={66}
                        height={15}
                        viewBox="0 0 66 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx={7} cy="7.5" r={7} fill="#1890FF" />
                        <circle cx={33} cy="7.5" r={7} fill="#F9C153" />
                        <circle cx={59} cy="7.5" r={7} fill="#F0536F" />
                    </svg>
                </Tooltip>
            </div>
        </div>
    );
};

export default DayLeftToolTip;
